"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function n(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var o = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, o.get ? o : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var o = n(e),
    _r = function r() {
  return (_r = Object.assign || function (e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      for (var r in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    c = function c(e) {
  var t = o.useState(e.get("scale") || 0),
      n = t[0],
      r = t[1],
      c = function c(e) {
    r(e);
  };

  return o.useEffect(function () {
    return e.subscribe("scale", c), function () {
      e.unsubscribe("scale", c);
    };
  }, []), {
    scale: n
  };
},
    a = function a(e) {
  var t = e.children,
      n = e.store;
  return (t || function (e) {
    return o.createElement(o.Fragment, null, Math.round(100 * e.scale) + "%");
  })({
    scale: c(n).scale
  });
},
    u = [.1, .2, .3, .4, .5, .6, .7, .8, .9, 1, 1.1, 1.3, 1.5, 1.7, 1.9, 2.1, 2.4, 2.7, 3, 3.3, 3.7, 4.1, 4.6, 5.1, 5.7, 6.3, 7, 7.7, 8.5, 9.4, 10],
    i = function i(e) {
  return u.find(function (t) {
    return t > e;
  }) || e;
},
    l = function l(e) {
  var t = u.findIndex(function (t) {
    return t >= e;
  });
  return -1 === t || 0 === t ? e : u[t - 1];
},
    m = function m(e) {
  var n = e.containerRef,
      r = e.store,
      c = function c(e) {
    if (!e.shiftKey && !e.altKey && (t.isMac() ? e.metaKey : e.ctrlKey)) {
      var o = n.current;

      if (o && document.activeElement && o.contains(document.activeElement)) {
        var c = r.get("zoom");

        if (c) {
          var a = r.get("scale") || 1,
              u = 1;

          switch (e.key) {
            case "-":
              u = l(a);
              break;

            case "=":
              u = i(a);
              break;

            case "0":
              u = 1;
              break;

            default:
              u = a;
          }

          u !== a && (e.preventDefault(), c(u));
        }
      }
    }
  };

  return o.useEffect(function () {
    if (n.current) return document.addEventListener("keydown", c), function () {
      document.removeEventListener("keydown", c);
    };
  }, [n.current]), o.createElement(o.Fragment, null);
},
    s = [.5, .75, 1, 1.25, 1.5, 2, 3, 4],
    f = {
  left: 0,
  top: 8
},
    p = function p(e) {
  var n = e.scale,
      r = e.onZoom,
      c = o.useContext(t.LocalizationContext).l10n,
      a = o.useContext(t.ThemeContext).direction === t.TextDirection.RightToLeft,
      u = c && c.zoom ? c.zoom.zoomDocument : "Zoom document";
  return o.createElement(t.Popover, {
    ariaControlsSuffix: "zoom",
    ariaHasPopup: "menu",
    position: t.Position.BottomCenter,
    target: function target(e) {
      return o.createElement(t.MinimalButton, {
        ariaLabel: u,
        onClick: function onClick() {
          e();
        }
      }, o.createElement("span", {
        className: "rpv-zoom__popover-target"
      }, o.createElement("span", {
        "data-testid": "zoom__popover-target-scale",
        className: t.classNames({
          "rpv-zoom__popover-target-scale": !0,
          "rpv-zoom__popover-target-scale--ltr": !a,
          "rpv-zoom__popover-target-scale--rtl": a
        })
      }, Math.round(100 * n), "%"), o.createElement("span", {
        className: "rpv-zoom__popover-target-arrow"
      })));
    },
    content: function content(e) {
      return o.createElement(t.Menu, null, Object.keys(t.SpecialZoomLevel).map(function (n) {
        var a = n;
        return o.createElement(t.MenuItem, {
          key: a,
          onClick: function onClick() {
            e(), r(a);
          }
        }, function (e) {
          switch (e) {
            case t.SpecialZoomLevel.ActualSize:
              return c && c.zoom ? c.zoom.actualSize : "Actual size";

            case t.SpecialZoomLevel.PageFit:
              return c && c.zoom ? c.zoom.pageFit : "Page fit";

            case t.SpecialZoomLevel.PageWidth:
              return c && c.zoom ? c.zoom.pageWidth : "Page width";
          }
        }(a));
      }), o.createElement(t.MenuDivider, null), s.map(function (n) {
        return o.createElement(t.MenuItem, {
          key: n,
          onClick: function onClick() {
            e(), r(n);
          }
        }, Math.round(100 * n) + "%");
      }));
    },
    offset: f,
    closeOnClickOutside: !0,
    closeOnEscape: !0
  });
},
    v = function v(e) {
  var t = e.children,
      n = e.store;
  return (t || function (e) {
    return o.createElement(p, {
      scale: e.scale,
      onZoom: e.onZoom
    });
  })({
    scale: c(n).scale,
    onZoom: function onZoom(e) {
      var t = n.get("zoom");
      t && t(e);
    }
  });
},
    z = function z() {
  return o.createElement(t.Icon, {
    ignoreDirection: !0,
    size: 16
  }, o.createElement("path", {
    d: "M10.5,0.499c5.523,0,10,4.477,10,10s-4.477,10-10,10s-10-4.477-10-10S4.977,0.499,10.5,0.499z\n            M23.5,23.499\n            l-5.929-5.929\n            M5.5,10.499h10\n            M10.5,5.499v10"
  }));
},
    E = {
  left: 0,
  top: 8
},
    d = function d(e) {
  var n = e.enableShortcuts,
      r = e.onClick,
      c = o.useContext(t.LocalizationContext).l10n,
      a = c && c.zoom ? c.zoom.zoomIn : "Zoom in",
      u = n ? t.isMac() ? "Meta+=" : "Ctrl+=" : "";
  return o.createElement(t.Tooltip, {
    ariaControlsSuffix: "zoom-in",
    position: t.Position.BottomCenter,
    target: o.createElement(t.MinimalButton, {
      ariaKeyShortcuts: u,
      ariaLabel: a,
      onClick: r
    }, o.createElement(z, null)),
    content: function content() {
      return a;
    },
    offset: E
  });
},
    C = function C(e) {
  var t = e.children,
      n = e.enableShortcuts,
      o = e.store,
      r = c(o).scale;
  return (t || d)({
    enableShortcuts: n,
    onClick: function onClick() {
      var e = o.get("zoom");
      e && e(i(r));
    }
  });
},
    h = function h() {
  return o.createElement(t.Icon, {
    ignoreDirection: !0,
    size: 16
  }, o.createElement("path", {
    d: "M10.5,0.499c5.523,0,10,4.477,10,10s-4.477,10-10,10s-10-4.477-10-10S4.977,0.499,10.5,0.499z\n            M23.5,23.499\n            l-5.929-5.929\n            M5.5,10.499h10"
  }));
},
    g = {
  left: 0,
  top: 8
},
    b = function b(e) {
  var n = e.enableShortcuts,
      r = e.onClick,
      c = o.useContext(t.LocalizationContext).l10n,
      a = c && c.zoom ? c.zoom.zoomOut : "Zoom out",
      u = n ? t.isMac() ? "Meta+-" : "Ctrl+-" : "";
  return o.createElement(t.Tooltip, {
    ariaControlsSuffix: "zoom-out",
    position: t.Position.BottomCenter,
    target: o.createElement(t.MinimalButton, {
      ariaKeyShortcuts: u,
      ariaLabel: a,
      onClick: r
    }, o.createElement(h, null)),
    content: function content() {
      return a;
    },
    offset: g
  });
},
    k = function k(e) {
  var t = e.children,
      n = e.enableShortcuts,
      o = e.store,
      r = c(o).scale;
  return (t || b)({
    enableShortcuts: n,
    onClick: function onClick() {
      var e = o.get("zoom");
      e && e(l(r));
    }
  });
},
    M = function M(e) {
  var n = e.onClick,
      r = o.useContext(t.LocalizationContext).l10n,
      c = r && r.zoom ? r.zoom.zoomIn : "Zoom in";
  return o.createElement(t.MenuItem, {
    icon: o.createElement(z, null),
    onClick: n
  }, c);
},
    S = function S(e) {
  var n = e.onClick,
      r = o.useContext(t.LocalizationContext).l10n,
      c = r && r.zoom ? r.zoom.zoomOut : "Zoom out";
  return o.createElement(t.MenuItem, {
    icon: o.createElement(h, null),
    onClick: n
  }, c);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


exports.ZoomInIcon = z, exports.ZoomOutIcon = h, exports.zoomPlugin = function (e) {
  var n = o.useMemo(function () {
    return Object.assign({}, {
      enableShortcuts: !0
    }, e);
  }, []),
      c = o.useMemo(function () {
    return t.createStore({});
  }, []),
      u = function u(e) {
    return o.createElement(C, _r({
      enableShortcuts: n.enableShortcuts
    }, e, {
      store: c
    }));
  },
      i = function i(e) {
    return o.createElement(k, _r({
      enableShortcuts: n.enableShortcuts
    }, e, {
      store: c
    }));
  },
      l = function l(e) {
    return o.createElement(v, _r({}, e, {
      store: c
    }));
  };

  return {
    renderViewer: function renderViewer(e) {
      var t = e.slot;
      if (!n.enableShortcuts) return t;
      var a = {
        children: o.createElement(o.Fragment, null, o.createElement(m, {
          containerRef: e.containerRef,
          store: c
        }), t.children)
      };
      return _r(_r({}, t), a);
    },
    install: function install(e) {
      c.update("zoom", e.zoom);
    },
    onViewerStateChange: function onViewerStateChange(e) {
      return c.update("scale", e.scale), e;
    },
    zoomTo: function zoomTo(e) {
      var t = c.get("zoom");
      t && t(e);
    },
    CurrentScale: function CurrentScale(e) {
      return o.createElement(a, _r({}, e, {
        store: c
      }));
    },
    ZoomIn: u,
    ZoomInButton: function ZoomInButton() {
      return o.createElement(u, null, function (e) {
        return o.createElement(d, _r({}, e));
      });
    },
    ZoomInMenuItem: function ZoomInMenuItem(e) {
      return o.createElement(u, null, function (t) {
        return o.createElement(M, {
          onClick: function onClick() {
            t.onClick(), e.onClick();
          }
        });
      });
    },
    ZoomOut: i,
    ZoomOutButton: function ZoomOutButton() {
      return o.createElement(i, null, function (e) {
        return o.createElement(b, _r({}, e));
      });
    },
    ZoomOutMenuItem: function ZoomOutMenuItem(e) {
      return o.createElement(i, null, function (t) {
        return o.createElement(S, {
          onClick: function onClick() {
            t.onClick(), e.onClick();
          }
        });
      });
    },
    Zoom: l,
    ZoomPopover: function ZoomPopover() {
      return o.createElement(l, null, function (e) {
        return o.createElement(p, _r({}, e));
      });
    }
  };
};